import { createUseStyles } from 'react-jss';
export function modalStyles(showBorder, showBackdrop) {
    return {
        modal: {
            borderRadius: 5,
            border: 'none',
            boxShadow: showBorder ? '0px 2px 6px rgba(0, 0, 0, 0.25)' : 'none',
            backgroundColor: showBorder ? '#fff' : 'transparent'
        },
        overlay: {
            backgroundColor: showBackdrop ? 'rgba(0,0,0,0.3)' : 'transparent',
            backdropFilter: showBackdrop ? 'blur(5px)' : 'blur(1px)'
        }
    };
}
export const useModalStyles = createUseStyles({
    // This fixes the flickering issue on close
    '@global': {
        '.react-responsive-modal-modal': {
            animationFillMode: 'forwards !important'
        },
        '.react-responsive-modal-overlay': {
            animationFillMode: 'forwards !important'
        }
    }
});
export default modalStyles;
